<template>
  <div>
    <div v-if="p.outlet_size && p.part_type== 'channel'" class="flex flex-col" :class=" toRightFlow ? 'items-end' : 'items-start'">
      <div v-if="! plainView" class="h-4 w-4 bg-black" :class="toRightFlow ? 'mr-1' : 'ml-1'">&nbsp;</div>
      <div class="h-10 w-px bg-black" :class="toRightFlow ? 'mr-1' : 'ml-1'">&nbsp;</div>
      <div class="text-xs">Outlet {{ p.outlet_size }}"</div>
    </div>
    <div v-else-if="bottomOutlet" class="group flex flex-col cursor-pointer" :class="toRightFlow ? 'items-end' : 'items-start'" @click="setChannel()">
      <div v-if="! plainView" class="h-4 w-4 bg-black group-hover:bg-blue-400" :class="toRightFlow ? 'mr-1' : 'ml-1'">&nbsp;</div>
      <div class="h-10 w-px bg-black" :class="toRightFlow ? 'mr-1' : 'ml-1'">&nbsp;</div>
      <div class="text-xs">Outlet {{ bottomOutlet.outlet_size }}"</div>
    </div>
    <div v-if="p.outlet_size && p.part_type== 'accessory'" class="flex flex-col" :class=" toRightFlow ? 'items-end' : 'items-start'">
      <div v-if="plainView" class="h-2 w-4 bg-black" :class="toRightFlow ? 'mr-1' : 'ml-1'">&nbsp;</div>
      <div class="h-4 w-px bg-black" :class="toRightFlow ? 'mr-1' : 'ml-1'">&nbsp;</div>
      <div class="text-xs">{{ p.outlet_size }}"</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    'p' : Object,
    'bottomOutlet' : [Object, Boolean],
    'plainView': Boolean,
    'toRightFlow': Boolean,
  },
  emits: ['input:model'],
  methods: {
    setChannel() {
      this.$emit('input:model', this.bottomOutlet)
    },
  },
}
</script>
